module.exports = __webpack_public_path__ + "img/3.8fa583c4.png";